"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var lazyLoader_1 = __importDefault(require("../modules/lazyLoader"));
var log_1 = __importDefault(require("./log"));
var Template = /** @class */ (function () {
    function Template() {
    }
    Template.prototype.getHTML = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var html, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (options.view) {
                            if (options.url.includes('?')) {
                                options.url += "&view=".concat(options.view);
                            }
                            else {
                                options.url += "?view=".concat(options.view);
                            }
                        }
                        if (options.sortBy) {
                            if (options.url.includes('?')) {
                                options.url += "&sort_by=".concat(options.sortBy);
                            }
                            else {
                                options.url += "?sort_by=".concat(options.sortBy);
                            }
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, axios_1.default)({
                                method: 'get',
                                url: options.url,
                                responseType: 'document'
                            })];
                    case 2:
                        response = _a.sent();
                        if (response)
                            html = response.data.querySelector(options.content).innerHTML;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        reject(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        resolve(html);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Template.prototype.getAndUpdateHTML = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = options.node;
                        return [4 /*yield*/, this.getHTML({
                                url: options.url,
                                content: options.content,
                                view: options.view ? options.view : null
                            })];
                    case 1:
                        _a.innerHTML = _b.sent();
                        lazyLoader_1.default.update();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _b.sent();
                        log_1.default.error(error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Template.prototype.getAndAppendHTML = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, error_3;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        _b = (_a = options.node).insertAdjacentHTML;
                        _c = ['beforeend'];
                        return [4 /*yield*/, this.getHTML({
                                url: options.url,
                                content: options.content,
                                view: options.view ? options.view : null,
                                sortBy: options.sortBy ? options.sortBy : null
                            })];
                    case 1:
                        _b.apply(_a, _c.concat([_d.sent()]));
                        lazyLoader_1.default.update();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _d.sent();
                        log_1.default.error(error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return Template;
}());
exports.default = new Template();
